/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AggregationResource } from './';
import {
    AggregationResourceFromJSON,
    AggregationResourceFromJSONTyped,
    AggregationResourceToJSON,
} from './';
import type { FreelancerProjectResource } from './';
import {
    FreelancerProjectResourceFromJSON,
    FreelancerProjectResourceFromJSONTyped,
    FreelancerProjectResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerProjectsManagementSearchResultResource
 */
export interface FreelancerProjectsManagementSearchResultResource {
    /**
     * 
     * @type {Array<FreelancerProjectResource>}
     * @memberof FreelancerProjectsManagementSearchResultResource
     */
    results: Array<FreelancerProjectResource>;
    /**
     * 
     * @type {number}
     * @memberof FreelancerProjectsManagementSearchResultResource
     */
    totalElements: number;
    /**
     * 
     * @type {{ [key: string]: Array<AggregationResource>; }}
     * @memberof FreelancerProjectsManagementSearchResultResource
     */
    aggregations: { [key: string]: Array<AggregationResource>; };
    /**
     * 
     * @type {string}
     * @memberof FreelancerProjectsManagementSearchResultResource
     */
    alternativeCompanyName?: string;
}

/**
 * Check if a given object implements the FreelancerProjectsManagementSearchResultResource interface.
 */
export function instanceOfFreelancerProjectsManagementSearchResultResource(value: object): value is FreelancerProjectsManagementSearchResultResource {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('aggregations' in value) || value['aggregations'] === undefined) return false;
    return true;
}

export function FreelancerProjectsManagementSearchResultResourceFromJSON(json: any): FreelancerProjectsManagementSearchResultResource {
    return FreelancerProjectsManagementSearchResultResourceFromJSONTyped(json, false);
}

export function FreelancerProjectsManagementSearchResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerProjectsManagementSearchResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(FreelancerProjectResourceFromJSON)),
        'totalElements': json['totalElements'],
        'aggregations': json['aggregations'],
        'alternativeCompanyName': json['alternativeCompanyName'] == null ? undefined : json['alternativeCompanyName'],
    };
}

export function FreelancerProjectsManagementSearchResultResourceToJSON(value?: FreelancerProjectsManagementSearchResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map((v) => FreelancerProjectResourceToJSON(v))),
        'totalElements': value['totalElements'],
        'aggregations': value['aggregations'],
        'alternativeCompanyName': value['alternativeCompanyName'],
    };
}

